import { NavLink } from "react-router-dom";
import { Button } from "react-bootstrap";

const SuccessfullSignup = () => {
  return (
    <div className="text-center">
      <p className="text-muted-sm">
        Your account has been successfully created and verified.
      </p>
      <div className="text-center">
        <p className="text-muted-sm mb-4">
          Thank you for signing up! Your account has been activated
          successfully. You’ll be redirected to the login page
          shortly.
        </p>

        <p className="text-muted-sm mb-4">
          Please log in using your email and password to continue.
        </p>

        <p className="text-muted-sm mb-4">
          Redirecting you to login in <strong>3 seconds</strong>…
        </p>

        <NavLink to="/login">
          <Button className="w-100 btn-primary-custom">
            Go to Login now
          </Button>
        </NavLink>
      </div>
    </div>
  );
};

export default SuccessfullSignup;
